import React from 'react'

type ChipTypes = {
  className: string
  children: React.ReactNode
}

const Chip = ({ className, children, ...props }: ChipTypes) => {
  return (
    <span className={`border rounded-lg text-center font-bold p-2 ${className}`} {...props}>
      {children}
    </span>
  )
}

export default Chip
